export default {
  bind(el, binding, vnode) {
    const input = vnode.elm.children[0]
    input.addEventListener('compositionstart', () => {
      vnode.inputLocking = true
    })
    input.addEventListener('compositionend', () => {
      vnode.inputLocking = false
      input.dispatchEvent(new Event('input'))
    })
    input.addEventListener('input', () => {
      if (vnode.inputLocking) {
        return
      }
      const oldValue = input.value
      let newValue = input.value.replace(/[^\d]/g, '')
      if (newValue) {
        switch (binding.value) {
          case 'zeroBefore':
            break
          case 'zeroCan':
            newValue = Number(newValue).toString()
            break
          default:
            newValue = newValue.replace(/^\b(0+)/gi, '')
        }
      }
      if (newValue !== oldValue) {
        input.value = newValue
        input.dispatchEvent(new Event('input'))
      }
    })
  }
}
